export const user_slice_name = 'USER';

export const user_thunks = {
  USER_GET_UX_SETTINGS: `${user_slice_name}/getUserUXSettings`,
  USER_GET_MARKETING_ALERTS: `${user_slice_name}/getUserMarketingAlerts`,
};

export const KNOWN_UXSETTINGS = {
  CONFIGURE_HYBRID_COMMISSION: 'configureHybridCommission',
  DISPLAY_PAYOUTPLANNER: 'displayPayoutPlanner',
  IS_YOUR_REF_READONLY: 'isYourRefReadOnly',
  HIDE_YOUR_REF: 'hideYourRef',
  DISPLAY_NEW_QUOTE_BUTTON: 'displayNewQuoteButton',
  IS_ALWAYS_ADVISED: 'isAlwaysAdvised',
  IS_INDEM_COMMISSION_ALLOWED: 'isIndemCommissionAllowed',
  OVERRIDE_QUOTE_DATE: 'overrideQuoteDate',
  OVERRIDE_QUOTE_DATE_BEYOND30DAYS: 'overrideQuoteDateBeyond30Days',
  HIDE_LIFE_ESSENTIALS: 'hideLifeEssentials',
  HIDE_LIFE_PROTECTION: 'hideLifeProtection',
  HIDE_CI_ESSENTIALS: 'hideCIEssentials',
  HIDE_CI_PROTECTION: 'hideCIProtection',
  HIDE_INCOME_PROTECTION: 'hideIncomeProtection',
  FIXED_INDEMNITY_PERCENTAGE: 'fixedIndemnityPercentage',
};

export const ADVISER_COOKIE_NAME = 'guardianAdviser';
export const ADVISER_QUERY_PARAM = 'id';
